import Vue from 'vue'
import App from './App.vue'
import router from './core/router';
import BootstrapVue from 'bootstrap-vue'
import store from './store';
import './dealerUi';
import "@dealer-group/dealerui/dist/index.css";
import './system/init';
import i18n from './i18n'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import rollbar from './core/rollbar';
Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueSweetalert2, {customClass: {
    confirmButton: 'btn btn-primary',
    cancelButton: 'btn btn-danger'
  },
  buttonsStyling: false});

rollbar(Vue);

new Vue({
  render: h => h(App),
  router,
  i18n,
  store
}).$mount('#app');
